import React, { useEffect, useState } from 'react';
import axios from 'axios';
import logoImg from '../img/logo512.png'; // Replace with your actual path
import { BASE_URL } from "../Config";
const ReceiptPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 const id = localStorage.getItem('user_id');

  const token = localStorage.getItem('token'); // Or get from context/state

  const queryParams = new URLSearchParams(window.location.search);
  const paymentId = queryParams.get('payment_id');

  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const url = paymentId
          ? `${BASE_URL}/api/receipt/${id}?payment_id=${paymentId}`
          : `${BASE_URL}/api/receipt/${id}`;
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(response.data.receipt);
        if (!response.data.receipt || response.data.receipt.receipt_no === null || response.data.receipt.receipt_no === "") {
          alert("Receipt is not available!");
          window.close(); // closes the tab
        }
      } catch (err) {
        setError('Failed to load receipt.');
      } finally {
        setLoading(false);
      }
    };

    fetchReceipt();
  }, [id, token, paymentId]);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB');
  };

  if (loading) return <p>Loading receipt...</p>;
  if (error) return <p>{error}</p>;

  const { confDetails, getFee, delInfo, receiptSetting } = data;

  return (
    <div id="myPage" className="container">
      <div className="text-center mt-4">
        <div className="logo">
          <img src={logoImg} alt="Logo" style={{ width: 120 }} />
        </div>
        <div className="header mt-2">
          <span style={{ fontWeight: 1000, color: '#830133', fontSize: 15, textTransform: 'uppercase' }}>
            BANARASI VASTRA UDYOG ASSOCIATION
          </span>
          <br />
          <span style={{ fontWeight: 500, color: '#830133', fontSize: 16 }}>
          
         
            (Regd. No.: 1501/2008-2009)
           
          </span>
        </div>
        <h3 className="mt-3">Membership Fee Receipt</h3>
      </div>

      <div className="border" style={{width:'100%', textAlign:'left'}}>

       <table className="table table-striped table-hover table-bordered shadow-sm"
       style={{ background: "#fdfdfd", borderRadius: "10px", overflow: "hidden" }}>
  <thead style={{ background: "linear-gradient(90deg, #ff9800, #ffc107)", color: "#fff" }}>
    
    <tr>
      <th colSpan={4} className="text-center fs-5">🪪 Membership Details</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="fw-bold text-dark">Receipt No</td>
      <td>{data.receipt_no}</td>
      <td className="fw-bold text-dark">Receipt Date</td>
      <td>{data.payment_date}</td>
    </tr>
    <tr>
      <td className="fw-bold text-dark" style={{ width: "25%" }}>Membership No.</td>
      <td colSpan={3}>{data.membership}</td>
    </tr>
    <tr>
      <td className="fw-bold text-dark">Firm Name</td>
      <td colSpan={3}>{data.name}</td>
    </tr>
    <tr>
      <td className="fw-bold text-dark">Email</td>
      <td>{data.email}</td>
      <td className="fw-bold text-dark">Phone</td>
      <td>{data.mobile}</td>
    </tr>
    <tr>
      <td className="fw-bold text-dark">Address</td>
      <td colSpan={3}>{data.address}</td>
    </tr>
  </tbody>
</table>

<table className="table table-striped table-hover table-bordered shadow-sm"
       style={{ background: "#fdfdfd", borderRadius: "10px", overflow: "hidden" }}>
  <thead style={{ background: "linear-gradient(90deg, #4caf50, #81c784)", color: "#fff" }}>
    <tr>
      <th colSpan={4} className="text-center fs-5">💳 Payment Details</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="fw-bold text-dark" style={{ width: "25%" }}>Payment Mode</td>
      <td colSpan={3}>Online</td>
    </tr>
    <tr>
      <td className="fw-bold text-dark">Transaction Date</td>
      <td colSpan={3}>{data.payment_date}</td>
    </tr>
    <tr>
      <td className="fw-bold text-dark">Amount</td>
      <td colSpan={3} className="fw-bold text-success">INR {data.membership_fee} .00</td>
    </tr>
  </tbody>
</table>

        <div className="row mt-4">
          <div className="col text-center">
          
            <p><strong>Signature</strong></p>
          </div>
          <div className="col text-center">
           
            <p><strong>Seal</strong></p>
          </div>
        </div>

        <div className="text-end mt-3">
          <button className="btn btn-primary" onClick={() => window.print()}>
            Print Receipt
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReceiptPage;
